export const BODY_PART_IDS = {
	EYES: 37,
	TEETH: 39,
}

export const BODY_PART_DEFAULT_RULES = [
	{
		key: 'eyes',
		bodyPartIds: [BODY_PART_IDS.EYES],
		overrides: { central: true, ita: false },
	},
	{
		key: 'teeth',
		bodyPartIds: [BODY_PART_IDS.TEETH],
		overrides: { central: true, ita: false },
	},
]

/**
 * Returns the overrides ({ central, ita }) for the selected body part,
 * or `null` if no applicable rule exists.
 *
 * @param {number|string|undefined} bodyPartId
 * @returns {{ central: boolean, ita: boolean } | null}
 */
export const getBodyPartDefaultRule = (bodyPartId) => {
	const id =
		bodyPartId != null && bodyPartId !== '' ? Number(bodyPartId) : null
	if (id == null) return null

	const rule = BODY_PART_DEFAULT_RULES.find((r) => r.bodyPartIds.includes(id))
	return rule ? rule.overrides : null
}
